<template>
    <div class="listCompanies scroll">
      <div class="content">
          <div v-if="loadCompanies" class="text-xs-center progress">
              <v-progress-circular indeterminate style="margin-top: 10px;"  color="primary"></v-progress-circular>
          </div>
          <div v-if="companies.length > 0">
            <div v-for="(company,index) in companies.slice(0, totalItems)" :key="index" class="companyItem" v-on:click="selectCompany(company)">
                    <span class="twoline companyTitle"> {{company.name}} ({{company.mainIdentifierCode}} : {{company.mainIdentifierValue}})
                        <span class="smalltext greytext"> {{company.streetNumber}} {{company.streetName}} {{company.postCode}} {{company.city}}, {{company.country}}
                        </span>
                    </span>
                    <hr class="divider">
            </div>
          </div>
          <div v-if="!loadCompanies && companies.length === 0">
            <p class="greytext" style="padding-top: 16px; margin-left: 9px;">{{labels.couldntFindCompanies}}</p>
          </div>
          <div v-if="showLoadCompanies" class="listfooter">
              <v-layout row>
                  <v-btn v-if="showNextBtn"  class="loadmorebtn" @click="nextResults">{{labels.loadMore}}</v-btn>
                  <a  v-if="!showNextBtn" v-bind:href="'mailto:'+config.contactUs" style="margin: auto; padding-top: 14px;">{{labels.cantFindCompanies}} </a>
              </v-layout>
          </div>
          <div v-if="!showLoadCompanies" class="emptyfooter">
            <a v-bind:href="'mailto:'+config.contactUs">{{labels.cantFindCompanies}} </a>
          </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: ['loadCompanies', 'companies'],
  data () {
    return {
      labels: {
        cantFindCompanies: this.$t('Company.SelectCompany.CANT_FIND_COMPANY_LINK'),
        loadMore: this.$t('Company.SelectCompany.LOAD_MORE_BTN'),
        couldntFindCompanies: this.$t('Company.SelectCompany.NO_COMPANY_FOUND_DESC')
      },
      totalItems: 5,
      pageIndex: 1,
      rowsPerPage: 5
    }
  },
  methods: {
    async selectCompany (company) {
      this.$emit('selectCompany', company)
    },
    nextResults () {
      this.pageIndex += 1
      this.totalItems = this.rowsPerPage * this.pageIndex
      $('.listCompanies').stop().animate({
        scrollTop: $('.listCompanies')[0].scrollHeight
      }, 800)
    },
    initPagination () {
      this.totalItems = 5
      this.pageIndex = 1
    }
  },
  computed: {
    ...mapState('siteconfig', ['config']),
    showNextBtn: function () {
      return this.totalItems < this.companies.length
    },
    showLoadCompanies: function () {
      return !this.loadCompanies && this.companies.length > this.rowsPerPage
    }
  }
}
</script>
<style scoped>
.listCompanies {
    width: 99.4%;
    background-color: #ffffff;
    min-height: 50px;
    max-height: 402px;
    overflow-y: scroll;
    float: left;
}
.content {
  width: 99.4%;
}

.scroll::-webkit-scrollbar {
  width: 10px;
}

.scroll::-webkit-scrollbar-thumb {
  background: #666;
  border-radius: 20px;
}

.scroll::-webkit-scrollbar-track {
  background: #ddd;
  border-radius: 20px;
}

.companyItem {
    width: 96%;
    padding-top: 16px;
    margin-left: 9px;
    cursor: pointer;
}
.companyItem:last-of-type {
  margin-bottom: 10px;
}
.companyTitle{
  font-size: 15px;
  font-weight: bold;
}
.divider {
    margin-top: 7px;
    border-top: 1px solid #e8e8e8;
    padding-top: 0px;
}
.listfooter {
   width: 100%;
   height: 62px;
   text-align: center;
}
.emptyfooter {
   width: 100%;
   height: 40px;
   text-align: center;
   margin-top: 10px;
}
</style>
